import $ from 'jquery';

$(function () {

    // Open the swatch modal
    $('[href="#order-a-swatch"]').on('click', event => {
        $('.js-sample-modal').addClass('active');
        $('.overlay').addClass('active');
    });

    // Close all modals
    $('.js-modal-close').on('click', event => {
        const $self = $(event.currentTarget);
        $self.parents('.modal').removeClass('active');
        $('.overlay').removeClass('active');
    });

});